import React, { useState } from "react";

import { DateRange } from "react-date-range";

import "react-date-range/dist/styles.css"; // main style file
import "react-date-range/dist/theme/default.css"; // theme css file

import { Popper, styled, CalendarMonth, makeStyles } from "../helper";
import ChallanBaseButton from "../Buttons/ChallanBaseButton";
import ChallanPopperButton from "../Buttons/ChallanPopperButton";

const StyledDiv = styled("div")({
  ".rdrDayToday .rdrDayNumber span:after": {
    backgroundColor: "rgba(226, 19, 110, 1)",
  },
  ".rdrCalendarWrapper": {
    borderRadius: "12px",
  },
});

const useStyles = makeStyles((theme) => ({
  popperWrapper: {
    background: "white",
    boxShadow: "0px 16px 24px rgba(54, 43, 115, 0.16)",
    borderRadius: 16,
  },
}));

export default function DateRangeSelect({ endDate, startDate, onChange }) {
  const classes = useStyles();
  const anchorRef = React.useRef();

  const [anchorEl, setAnchorEl] = useState(null);
  const [state, setState] = React.useState([
    {
      startDate: startDate ? new Date(startDate) : new Date(endDate),
      endDate: new Date(endDate),
      key: "selection",
    },
  ]);

  const handleClick = () => {
    setTimeout(() => setAnchorEl(anchorRef?.current), 1);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleDone = () => {
    const [{ startDate, endDate }] = state;
    onChange(startDate, endDate);
    handleClose();
  };

  const open = Boolean(anchorEl);

  return (
    <div ref={anchorRef}>
      <Popper anchorEl={anchorEl} open={open} onClose={handleClose}>
        <div className={classes.popperWrapper}>
          <StyledDiv>
            <DateRange
              rangeColors={["rgba(226, 19, 110, 1)", "rgba(54, 43, 115, 1)"]}
              onChange={(item) => setState([item.selection])}
              moveRangeOnFirstSelection={false}
              ranges={state}
            />
          </StyledDiv>
          <div
            style={{
              display: "flex",
              justifyContent: "space-around",
              paddingBottom: 16,
            }}
          >
            <ChallanBaseButton
              onClick={handleClose}
              text={"Cancel"}
              type={"cancel"}
              width={"40%"}
            />
            <ChallanBaseButton
              onClick={handleDone}
              text={"Apply"}
              type={"ok"}
              width={"40%"}
            />
          </div>
        </div>
      </Popper>

      <ChallanPopperButton
        width={220}
        onClick={handleClick}
        gutter={[1, 0, 0]}
        borderColor={"#E2136E"}
      >
        <span style={{ marginRight: 8 }}>Select Date Range...</span>
        <CalendarMonth style={{ color: "#E2136E" }} />
      </ChallanPopperButton>
    </div>
  );
}
